let DateFormatConstant = /** @class */ (() => {
    class DateFormatConstant {
        static DateFormatClientDMY() {
            return "dd/MM/yyyy";
        }
        static DateFormatClientMDY() {
            return "MM/dd/yyyy";
        }
        static RecurrenceDateFormat() {
            return "MM/DD/YYYY";
        }
    }
    DateFormatConstant.DateFormat = class {
        static DateFormatDMY() {
            return "DD/MM/YYYY";
        }
        static DateFormatMDY() {
            return "MM/DD/YYYY";
        }
    };
    return DateFormatConstant;
})();
export { DateFormatConstant };
